import request from "@/utils/request";

// 字典列表获取
export const getDict = (code) => {
  return request({
    url: `/api/parking-base/sys_dict/${code}`,
    method: "get",
  });
};
